<template>
  <div>
    <div class="mt-2 font-weight-bold">
      {{ $t('forms.action.PayerUpdateInfo') }}
    </div>
    <hr>

    <div
      v-for="p in properties"
      :key="p.code"
      class="row no-gutters align-items-center mt-2 rule-row"
    >
      <div class="col-4">
        <span class="pr-2 mb-0 small text-secondary">
          <i :class="`${getIcon(p.type)} pr-2`" />
          {{ p.name }}
        </span>
      </div>
      <div class="col-8 pr-1">
        <FieldOrRule
          v-model="mapping[p.code]"
          :layout="layout"
        />
      </div>
    </div>
    <hr>
    <ActionEnabled
      v-model="mapping.actionRule"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ActionEnabled from './ActionEnabled';
import FieldOrRule from './FieldOrRule';

export default {
  props: {
    metadata: Object,
    layout: Array,
  },
  data: () => ({
    mapping: {},
  }),
  components: {
    FieldOrRule,
    ActionEnabled,
  },
  computed: {
    ...mapGetters([
      'properties',
      'payersPropertyTypes',
    ]),
    model() {
      return {
        actionRule: this.mapping.actionRule,
        properties: this.properties
          .map((x) => ({
            key: x.code,
            value: this.mapping[x.code],
          }))
          .filter((x) => x.value),
      };
    },
  },
  watch: {
    model: {
      deep: true,
      handler(newVal) {
        this.$emit('update:metadata', newVal);
      },
    },
  },
  methods: {
    getIcon(type) {
      return this.payersPropertyTypes.find((x) => x.key === type)?.icon;
    },
  },
  created() {
    const model = this.metadata;

    this.$set(this.mapping, 'actionRule', model.actionRule);

    this.properties.forEach((x) => {
      const prop = (model.properties || []).find((y) => y.key === x.code);
      if (prop && prop.value) {
        this.$set(this.mapping, prop.key, prop.value);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.rule-row {
  padding-left: 5px;

  &:hover {
    background-color: #fafafa;
  }
}
</style>
